// What an analysis page says about how up to date its insights are. After a model changes, the server works out the
// insights again: the current state's first, then each project's in the background. Pure, so it can be tested without
// a page; the insights status component shows it

// the server's account of an organisation's insights: the workspaces being worked out, and when each last was
export interface InsightsStatus {
    refreshing: string[];
    updated: { [workspaceKey: string]: string | Date };
}

export type InsightsNotice =
    | 'none'
    | 'local'       // this page asked for them to be worked out again, and is waiting for them
    | 'remote'      // they are being worked out again, as asked for elsewhere: the figures shown may be out of date
    | 'ready';      // they were being worked out while the page was open, and the new ones can be shown

export interface NoticeState {
    notice: InsightsNotice;
    sawRemote: boolean;     // the workspace was seen being worked out while the page was open
}

// what to say, from whether this page is waiting on a refresh, the server's status for the workspace shown, and what
// was said before. The new figures are offered once a refresh seen from here has finished, until the page reloads
export const nextNotice = (previous: NoticeState, localRefreshing: boolean, status: InsightsStatus | undefined, workspaceKey: string): NoticeState => {
    const remote = !!status?.refreshing.includes(workspaceKey);
    if (localRefreshing) return { notice: 'local', sawRemote: false };
    if (remote) return { notice: 'remote', sawRemote: true };
    if (previous.sawRemote || previous.notice === 'ready') return { notice: 'ready', sawRemote: false };
    return { notice: 'none', sawRemote: false };
};
